import { render, staticRenderFns } from "./UserBlurb.vue?vue&type=template&id=7cb7237c"
import script from "./UserBlurb.vue?vue&type=script&lang=js"
export * from "./UserBlurb.vue?vue&type=script&lang=js"
import style0 from "./UserBlurb.vue?vue&type=style&index=0&id=7cb7237c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports